import Usuario from './Usuario'
import Serie from './Serie'
import moment from 'moment';

var date = moment().format('YYYY-MM-DD');
class FaixaAit {
    constructor(
        {
            id = null,
            serie_id = null,
            num_inicio = null,
            num_fim = null,
            data_recebimento = null,
            quantidade = null,
            ind_ativo = true,
            created_at = null,
            updated_at = null,
            deleted_at = null,

            //ORM
            usuario = {},
            serie = {},
            auto_infracao_transito = [],
        } = {}
    ) {
        this.id = id;
        this.serie_id = serie_id,
        this.num_inicio = num_inicio;
        this.num_fim = num_fim;
        this.data_recebimento = data_recebimento ? data_recebimento : date;
        this.ind_ativo = ind_ativo;
        this.quantidade = quantidade;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;

        //ORM
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();
        this.serie = serie ? new Serie(serie) : new Serie();
        this.auto_infracao_transito = auto_infracao_transito;
    }
}

export default FaixaAit;